import { UserFilterInput, UserGroupFilterInput } from "../../../../../Utilities";
import { useUserAndUserGroupRecipients } from "../Recipients";

export function useRecipients(
	search?: string | null,
	userFilterInput?: UserFilterInput,
	userGroupFilterInput?: UserGroupFilterInput,
) {
	return useUserAndUserGroupRecipients(search, userFilterInput, userGroupFilterInput);
}
